import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../Constant/Dashboardeng.json";
import translationMR from "../Constant/Dashboardmr.json";
import ProfileEN from "../Constant/ProfileSettingEng.json";
import ProfileMR from "../Constant/ProfileSettingsMar.json";
import IECModuleEN from "../Constant/IECModuleEng.json";
import IECModuleMR from "../Constant/IECModuleMar.json";
import SchemeEN from "../Constant/ASHADetailsSchemesEng.json";
import SchemeMR from "../Constant/ASHADetailsSchemesMar.json";
import IncentiveEN from "../Constant/ASHAIncentiveActivitiesEng1.json";
import IncentiveMR from "../Constant/ASHAIncentiveActivitiesMar.json";
import AshaProfileEN from "../Constant/ASHAProfileDetailsEng.json";
import AshaProfileMR from "../Constant/ASHAProfileDetailsMar.json";
import TopAshaEN from "../Constant/ASHABasedPerformanceEng.json";
import TopAshaMR from "../Constant/ASHAListperformanceMar.json";
import AnmDetailsPhcMR from "../Constant/AnmDetails-PhcMar.json";
import AnmDetailsPhcEN from "../Constant/AnmDetails-PhcEng.json";
import AnmDetailUpdateMR from "../Constant/ANM-Details-update-mar.json";
import AnmDetailUpdateEN from "../Constant/ANM-Details-update-eng.json";
import AnmTransferMappingEN from "../Constant/ANM-Transfer-Mapping-Eng.json";
import AnmTransferMappingMR from "../Constant/ANM-Transfer-Mapping-Mar.json";
import ChangeLanguageMR from "../Constant/ChangeLanguageMar.json";
import MasterViewMR from "../Constant/MasterTranslation/MasterViewMar.json";
import MasterViewEng from "../Constant/MasterTranslation/MasterViewEng.json";
import MasterFormMr from "../Constant/MasterTranslation/MasterFormMar.json";
import MasterFormEng from "../Constant/MasterTranslation/MasterFormEng.json";
import masterTableEng from "../Constant/MasterTranslation/MasterTableEng.json";
import masterTableMar from "../Constant/MasterTranslation/MasterTableMar.json";
import masterApiErrorMessageMar from "../Constant/MasterTranslation/MasterApiErrorMessageMar.json";
import masterApiErrorMessageDeleteMar from "../Constant/MasterTranslation/masterApiErrorMessageDeleteMar.json";
import masterApiErrorMessageEng from "../Constant/MasterTranslation/MasterApiErrorMessageEng.json";
import masterApiErrorMessageDeleteEng from "../Constant/MasterTranslation/masterApiErrorMessageDeleteEng.json";
import AfDetailUpdateEN from "../Constant/AF-Details-update-eng.json";

const resources = {
  en: {
    translation: translationEN,
    profile: ProfileEN,
    Iec: IECModuleEN,
    anmdetailsPhc: AnmDetailsPhcEN,
    AnmTransferPhc: AnmTransferMappingEN,
    AnmDetailsUpdatePhc: AnmDetailUpdateEN,
    AfDetailsUpdatePhc: AfDetailUpdateEN,
    Scheme: SchemeEN,
    Incentive: IncentiveEN,
    AshaProfile: AshaProfileEN,
    TopAsha: TopAshaEN,
    master: {
      ...MasterViewEng,
      ...MasterFormEng,
      ...masterTableEng,
      ...masterApiErrorMessageEng,
      ...masterApiErrorMessageDeleteEng,
    },
  },
  mr: {
    translation: translationMR,
    profile: ProfileMR,
    Iec: IECModuleMR,
    anmdetailsPhc: AnmDetailsPhcMR,
    AnmDetailsUpdatePhc: AnmDetailUpdateMR,
    AnmTransferPhc: AnmTransferMappingMR,
    Scheme: SchemeMR,
    Incentive: IncentiveMR,
    AshaProfile: AshaProfileMR,
    TopAsha: TopAshaMR,
    ChangeLanguage: ChangeLanguageMR,
    master: {
      ...MasterViewMR,
      ...MasterFormMr,
      ...masterTableMar,
      ...masterApiErrorMessageMar,
      ...masterApiErrorMessageDeleteMar,
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
